export interface MaintenanceConfig {
    maintenance_page_toggle: boolean;
    maintenance_page_redirect: string;
}

export async function fetchMaintenanceConfig(
    cmsBaseUrl: string,
    cmsAppId: string,
    cmsContentType: string
): Promise<MaintenanceConfig> {
    if (!cmsBaseUrl || !cmsAppId || !cmsContentType) {
        return { maintenance_page_toggle: false, maintenance_page_redirect: '' };
    }

    const cmsUrl =
        `${cmsBaseUrl}/websiteContents` +
        `?ApplicationId=${encodeURIComponent(cmsAppId)}` +
        `&ContentType=${encodeURIComponent(cmsContentType)}`;

    const res = await fetch(cmsUrl, { cache: "no-store" });
    if (!res.ok) {
        throw new Error(`Failed to load maintenance config (${res.status})`);
    }

    const body = await res.json() as {
        totalRecords: number;
        contents: Array<{
            content: {
                maintenance_page_toggle?: boolean;
                maintenance_page_redirect?: string;
                [key: string]: any;
            };
        }>;
    };

    if (
        !body.contents ||
        body.contents.length === 0 ||
        !body.contents[0].content
    ) {
        return {
            maintenance_page_toggle: false,
            maintenance_page_redirect: "",
        };
    }

    const { maintenance_page_toggle, maintenance_page_redirect } =
        body.contents[0].content;

    return {
        maintenance_page_toggle: !!maintenance_page_toggle,
        maintenance_page_redirect: maintenance_page_redirect ?? "",
    };
}
